import { render } from "./designList.vue?vue&type=template&id=528194da"
import script from "./designList.vue?vue&type=script&lang=js"
export * from "./designList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__